export default __webpack_public_path__ + "static/media/Python.4e596e51.png";